import { render, staticRenderFns } from "./SNPMB-Soal.vue?vue&type=template&id=42befb35&"
import script from "./SNPMB-Soal.vue?vue&type=script&lang=js&"
export * from "./SNPMB-Soal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports